export default __webpack_public_path__ + "static/media/131.4d55f8b1.png";